module.exports = __webpack_public_path__ + "img/pick2_g.3199863e.png";